import { defineStore } from 'pinia'
import { setSystemInfo as setSystemInfoStore, getSystemInfo } from '@/services/utils/auth'
import { API } from '@/services/api/main'
import request from '@/services/utils/request'

const useAppStore = defineStore('app', {
    state: () => ({
        systemInfo: getSystemInfo() || {},
        homeBanner: [] as any[],
        noticeList: [] as any[],
        todayActivity: [] as any[],
        newsFeed: [] as any[],
        hotStrategy: [] as any[],
        hotTravel: [] as any[]
    }),
    actions: {
        // 设置系统信息
        setSystemInfo(systemInfo) {
            setSystemInfoStore(systemInfo)
            this.$patch({ systemInfo })
        },
        // 获取首页轮播图
        async getHomeBanner() {
            const data = await request({ ...API.getHomeBanner, data: {} })
            this.homeBanner = data.data
        },
        // 获取公告列表
        async getNoticeList() {
            const data = await request({ ...API.getNoticeList, data: { type: 1, pageNo: 1, pageSize: 10 } })
            this.noticeList = data.data.list
        },
        // 今日精彩活动
        async getTodayActivity() {
            const data = await request({ ...API.getActivityList, data: { page: 1, pageSize: 10, nowTime: new Date().getTime() } })
            this.todayActivity = data.data.list
        },
        // 新鲜事
        async getNewsFeed() {
            const data = await request({ ...API.getNoticeList, data: { type: 4, pageNo: 1, pageSize: 6 } })
            this.newsFeed = data.data.list
        },
        // 热门攻略
        async getHotStrategy() {
            const data = await request({ ...API.getNoticeList, data: { type: 2, pageNo: 1, pageSize: 3 } })
            this.hotStrategy = data.data.list
        },
        // 热门游记
        async getHotTravel() {
            const data = await request({ ...API.getNoticeList, data: { type: 3, pageNo: 1, pageSize: 3 } })
            this.hotTravel = data.data.list
        },
        // 请求所有接口
        async getHomeData() {
            await Promise.all([this.getHomeBanner(), this.getNoticeList(), this.getTodayActivity(), this.getNewsFeed(), this.getHotStrategy(), this.getHotTravel()])
        }
    }
})

export { useAppStore }
